<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert type="info" show-icon style="margin-bottom: 16px" message="优惠券规则说明">
        <template slot="description">
          <div>① 全部为用户在 App 首页 <strong>Claim Coupon</strong> 弹窗自行领取，不再区分领取方式。</div>
          <div style="margin-top: 4px">② 同一券模板每人仅可领取 1 张；使用有效期为配置的<strong>有效起止日期</strong>。</div>
          <div style="margin-top: 4px">③ 平台券另设「领取有效期」：未领取且超过领取失效时间则 App 不再展示；已领取的仍按使用有效期展示。</div>
          <div style="margin-top: 4px">④ 以下时间字段均按 <strong>尼日利亚时间 (Africa/Lagos, UTC+1)</strong> 录入并存储；默认值也按此时区生成。</div>
        </template>
      </a-alert>

      <div class="table-page-search-wrapper">
        <a-button type="primary" @click="handleAdd"><a-icon type="plus" />新增优惠券</a-button>
      </div>

      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1500 }"
      >
        <span slot="couponKind" slot-scope="text">{{ text === 1 ? '新人优惠券' : '平台优惠券' }}</span>
        <span slot="bonusValue" slot-scope="text, record">+{{ text }} <span class="text-muted">(满{{ record.minAmount || 0 }})</span></span>
        <span slot="totalQuantity" slot-scope="text">{{ text === 0 || text == null ? '不限' : text }}</span>
        <span slot="validRange" slot-scope="text, record">
          {{ record.validStartTime || '—' }} ~ {{ record.validEndTime || '—' }}
        </span>
        <span slot="claimWindow" slot-scope="text, record">
          <template v-if="record.couponKind === 2 && record.claimStartTime">
            {{ record.claimStartTime }} ~ {{ record.claimEndTime || '—' }}
          </template>
          <span v-else class="text-muted">—</span>
        </span>
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">删除</a>
        </span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
      />
    </a-card>

    <a-modal :title="formTitle" :visible="open" @ok="submitForm" @cancel="open = false" :confirmLoading="submitLoading" width="720px">
      <a-form-model :model="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
        <a-form-model-item label="名称" required>
          <a-input v-model="form.name" placeholder="如 New User Exclusive Coupon" />
        </a-form-model-item>
        <a-form-model-item label="优惠券种类" required>
          <a-radio-group v-model="form.couponKind" @change="onCouponKindChange">
            <a-radio :value="1">新人优惠券</a-radio>
            <a-radio :value="2">平台优惠券</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.couponKind === 2" label="领取开始时间" required>
          <a-date-picker v-model="form.claimStartTime" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" />
          <div class="form-tip">按尼日利亚时间 (UTC+1) 录入，默认当前 WAT</div>
        </a-form-model-item>
        <a-form-model-item v-if="form.couponKind === 2" label="领取失效时间" required>
          <a-date-picker v-model="form.claimEndTime" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" />
          <div class="form-tip">按尼日利亚时间 (UTC+1) 录入，默认领取开始 + 30 天 (WAT)</div>
        </a-form-model-item>
        <a-form-model-item label="使用有效开始" required>
          <a-date-picker v-model="form.validStartTime" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" />
          <div class="form-tip">按尼日利亚时间 (UTC+1) 录入，默认当前 WAT</div>
        </a-form-model-item>
        <a-form-model-item label="使用有效结束" required>
          <a-date-picker v-model="form.validEndTime" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" />
          <div class="form-tip">按尼日利亚时间 (UTC+1) 录入，默认使用开始 + 30 天 (WAT)；App 展示 Valid from … to …</div>
        </a-form-model-item>
        <a-form-model-item label="满加金额" required>
          <a-input-number v-model="form.bonusValue" :min="0" :step="0.01" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="满加门槛">
          <a-input-number v-model="form.minAmount" :min="0" :step="0.01" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="可领取总数量">
          <a-input-number v-model="form.totalQuantity" :min="0" :step="1" style="width:100%" />
          <div class="form-tip">0 表示不限</div>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-switch :checked="form.status === 1" checked-children="启用" un-checked-children="禁用" @change="v => form.status = v ? 1 : 0" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageCoupon, saveCoupon, deleteCoupon } from '@/api/giftcard/coupon'
import { watNow, watNowAddDays } from '@/utils/wat-time'

const defaultForm = () => {
  const start = watNow()
  const end = watNowAddDays(30)
  return {
    id: null,
    name: '',
    couponKind: 2,
    bonusValue: 0,
    minAmount: 0,
    totalQuantity: 0,
    validStartTime: start,
    validEndTime: end,
    claimStartTime: start,
    claimEndTime: end,
    status: 1,
    claimMode: 2,
    newUserOnly: 0
  }
}

export default {
  name: 'GiftcardCoupon',
  data() {
    return {
      loading: false,
      submitLoading: false,
      open: false,
      formTitle: '',
      list: [],
      total: 0,
      queryParam: { pageNum: 1, pageSize: 10 },
      form: defaultForm(),
      columns: [
        { title: 'ID', dataIndex: 'id', width: 70, fixed: 'left' },
        { title: '名称', dataIndex: 'name', width: 160, ellipsis: true },
        { title: '种类', dataIndex: 'couponKind', scopedSlots: { customRender: 'couponKind' }, width: 110 },
        { title: '满加规则', dataIndex: 'bonusValue', scopedSlots: { customRender: 'bonusValue' }, width: 130 },
        { title: '总数量', dataIndex: 'totalQuantity', scopedSlots: { customRender: 'totalQuantity' }, width: 80 },
        { title: '使用有效期', scopedSlots: { customRender: 'validRange' }, width: 280 },
        { title: '领取有效期', scopedSlots: { customRender: 'claimWindow' }, width: 280 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120, fixed: 'right' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    normalizeRecord(record) {
      const couponKind = record.couponKind != null ? record.couponKind : (record.newUserOnly === 1 ? 1 : 2)
      return {
        ...record,
        couponKind,
        claimMode: 2,
        bonusValue: record.bonusValue == null ? 0 : record.bonusValue,
        minAmount: record.minAmount == null ? 0 : record.minAmount,
        totalQuantity: record.totalQuantity == null ? 0 : record.totalQuantity,
        status: record.status == null ? 1 : record.status
      }
    },
    onCouponKindChange(e) {
      if (e.target.value === 1) {
        this.form.claimStartTime = null
        this.form.claimEndTime = null
      }
    },
    getList() {
      this.loading = true
      pageCoupon(this.queryParam).then(res => {
        this.list = (res.data.records || []).map(r => this.normalizeRecord(r))
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    resetForm() {
      this.form = defaultForm()
    },
    handleAdd() {
      this.resetForm()
      this.formTitle = '新增优惠券'
      this.open = true
    },
    handleEdit(record) {
      this.form = this.normalizeRecord(record)
      this.formTitle = '编辑优惠券'
      this.open = true
    },
    submitForm() {
      if (!this.form.name || !this.form.name.trim()) {
        this.$message.warning('请输入优惠券名称')
        return
      }
      if (this.form.bonusValue == null || this.form.bonusValue <= 0) {
        this.$message.warning('请输入有效的满加金额')
        return
      }
      if (!this.form.validStartTime || !this.form.validEndTime) {
        this.$message.warning('请设置使用有效起止时间')
        return
      }
      if (this.form.couponKind === 2) {
        if (!this.form.claimStartTime || !this.form.claimEndTime) {
          this.$message.warning('平台优惠券请设置领取起止时间')
          return
        }
      }
      const payload = this.normalizeRecord(this.form)
      payload.claimMode = 2
      if (payload.couponKind === 1) {
        payload.newUserOnly = 1
        payload.claimStartTime = null
        payload.claimEndTime = null
      } else {
        payload.newUserOnly = 0
      }
      this.submitLoading = true
      saveCoupon(payload).then(() => {
        this.$message.success('保存成功')
        this.open = false
        this.getList()
      }).finally(() => { this.submitLoading = false })
    },
    handleDelete(record) {
      const self = this
      this.$confirm({
        title: '确认删除该优惠券？',
        content: '已领取的用户券不受影响，仅删除模板。',
        onOk() {
          return deleteCoupon(record.id).then(() => {
            self.$message.success('删除成功')
            self.getList()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.form-tip { color: rgba(0, 0, 0, 0.45); font-size: 12px; margin-top: 4px; }
.text-muted { color: rgba(0, 0, 0, 0.45); font-size: 13px; }
</style>
